import { ParameterEditorValue } from "../../processEditor/model/ParameterEditorValue";
import { HashMap } from "../../shared/model/HashMap";
import { ITriggerParameter, Process } from "./Process";

export interface IRunOnceTriggerData {
    id: number;
    triggerData: HashMap<string | ParameterEditorValue | undefined>;
}

export interface IRunOnceProcessModel extends IRunOnceTriggerData {
    processName?: string;
    parameters?: ITriggerParameter[];
}

export class RunOnceDialogState {
    public showRunOnce = false;
    public agentGroup: string;
    public runOnceProcessModel: IRunOnceProcessModel[];
    public processes: Process[];

    constructor(processes: Process[] = [], agentGroupName: string = "", manualTriggerParameters: HashMap<ITriggerParameter[]> = {}) {
        this.agentGroup = agentGroupName;
        this.showRunOnce = processes.length !== 0;
        this.processes = processes;
        this.runOnceProcessModel = processes.map((process): IRunOnceProcessModel => {
            const input: { [key: string]: string | ParameterEditorValue | undefined } = {};
            for (const parameter of manualTriggerParameters[process.uniqueIdentifier]) {
                input[parameter.name] = parameter.nonStringifiedDefaultValue;
            }
            return {
                id: process.id,
                triggerData: input,
                processName: process.name,
                parameters: manualTriggerParameters[process.uniqueIdentifier]
            };
        }
        );
    }
}
